import { haveValue } from "../../helper/common";
import useTranslator from "../../hooks/useTranslator";
import Cancelimg from "../../assets/img/cancel-01.svg";
import { LuCameraOff } from "react-icons/lu";
import styles from "./authenticateYourId/authenticateYourId.module.css";

const ProcessFailedModal = ({
  showPopup,
  isGuarantor,
  heading,
  subheading,
  closeModalState,
  hideBackgroundImage,
  buttonText,
}) => {
  const { _t } = useTranslator();
  return (
    <>
      {showPopup && (
        <div
          className={`popup-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 wrapper-modal modal-fixed-screen ${
            isGuarantor ? "guarantorBg" : ""
          } ${hideBackgroundImage ? "hideBackgroundImage" : ""}`}
        >
          <div className="popup-content2 popup-content bg-white kycDonePopup position-relative">
            <div className="kyc-failed-close-top-button">
              <button
                type="button"
                className={`${styles.customKycToolbarButton} ${styles.customKycToolbarClose}`}
                onClick={closeModalState}
                aria-label={_t("close")}
              >
                <img src={Cancelimg} alt="" />
              </button>
            </div>
            <div className="row relativeposition     mt-3">
              <div className="col-12 d-flex gap-4 align-items-center justify-content-center heading-section">
                <div className="authenticateid-header text-center">
                  <img
                    className="kyc-failed-heading-icon"
                    src="/images/high-risk-icon.svg"
                  />
                  <h4>{heading}</h4>
                  <p>{subheading}</p>
                </div>
              </div>
            </div>
            <div className="text-center py-3 mb-2">
              <div className="kyc-failed-error-alert">
                <div className="kyc-failed-error-alert__icon">
                  <LuCameraOff color="#FF3C3C" size={18} />
                </div>

                <div className="kyc-failed-error-alert__content">
                  The document has expired. Please use a valid document, such as
                  your passport or another photo ID.
                </div>
              </div>
              {/* <div className="animate-slow-bounce"> */}
              {/* <div className="circle-container"> */}
              {/* 'X' Cross */}
              {/* <div className="x-wrapper"> */}
              {/* First bar of 'X' */}
              {/* <div className="x-bar rotate"></div> */}
              {/* Second bar of 'X' */}
              {/* <div className="x-bar reverse-rotate"></div>
                  </div>
                </div> */}
              {/* </div> */}
            </div>
            <div className="d-flex flex-wrap align-items-center justify-content-between kyc-failed-button">
              <button
                type="button"
                className="btnNext w-100 btnnextpre  uploadbtn kyc_failed_primary full_radius custom-mb-3"
                onClick={(e) => closeModalState(false)}
              >
                {haveValue(buttonText)
                  ? _t(buttonText)
                  : _t("goBackAndReupload")}
              </button>
              <button
                type="button"
                className="btnNext w-100 btnnextpre uploadbtn go_back_btn full_radius custom-mb-3"
                onClick={(e) => closeModalState(false)}
              >
                {haveValue(buttonText)
                  ? _t(buttonText)
                  : _t("goBackAndReupload")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProcessFailedModal;
